import { ModuleBase, QuoteElement } from '@/components';
import { ModuleBaseModel, ModuleBasePropsModel, QuoteModel } from '@/types';

type QuoteModuleModel = ModuleBaseModel<
  {
    quote: QuoteModel;
  } & ModuleBasePropsModel
>;

const QuoteModule = (data: QuoteModuleModel) => {
  const {
    props: { quote, backgroundColour },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="py-10 lg:py-16">
      <div className="container">
        <QuoteElement quote={quote} backgroundColor={backgroundColour} />
      </div>
    </ModuleBase>
  );
};

export default QuoteModule;
